export const useElementSize = (el: HTMLElement) => {
    const style = getComputedStyle(el)

    return {
        width: el.getBoundingClientRect().width,
        innerWidth: el.clientWidth,
        outerWidth: el.offsetWidth,
        outerWidthWithMargin: el.getBoundingClientRect().width + parseFloat(style.marginLeft) + parseFloat(style.marginRight),

        height: el.getBoundingClientRect().height,
        innerHeight: el.clientHeight,
        outerHeight: el.offsetHeight,
        outerHeightWithMargin: el.getBoundingClientRect().height + parseFloat(style.marginTop) + parseFloat(style.marginBottom),
    }
}
